import { render, staticRenderFns } from "./unassigned_task.vue?vue&type=template&id=3bcaa360&scoped=true&"
import script from "./unassigned_task.vue?vue&type=script&lang=js&"
export * from "./unassigned_task.vue?vue&type=script&lang=js&"
import style0 from "./unassigned_task.vue?vue&type=style&index=0&id=3bcaa360&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcaa360",
  null
  
)

export default component.exports